import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { getLoginColorAndLogo, getLoginLogo } from "../../Login/api/apiCalls"
import { hexToHsl } from "../../../services/functions"

/** Rahmen der öffentlichen Passwort-Seiten (wie die Login-Seite: Logo und Primärfarbe aus den öffentlichen Endpunkten). */
export default function PasswordPageLayout({ title, children }: { title: string; children: React.ReactNode }) {
    const { data: colorAndLogo } = useQuery({
        queryKey: ["login_color_and_logo"],
        queryFn: getLoginColorAndLogo,
        retry: false,
    })
    const { data: logo } = useQuery({
        queryKey: ["login_logo"],
        queryFn: getLoginLogo,
        enabled: !!colorAndLogo?.logo?.s3Key,
        retry: false,
    })

    useEffect(() => {
        if (colorAndLogo?.color) {
            document.documentElement.style.setProperty("--p", hexToHsl(`${colorAndLogo.color}`))
            document.documentElement.style.setProperty("--p-hex", `${colorAndLogo.color}`)
            document.documentElement.style.setProperty("--p-hex-50", `${colorAndLogo.color}50`)
        }
    }, [colorAndLogo])

    return (
        <main className="flex items-center justify-center w-screen min-h-screen bg-base-100 p-4">
            <div className="w-full max-w-md bg-white rounded-default shadow-lg p-8 flex flex-col gap-6">
                <div className="flex justify-center">
                    <img src={logo ?? "/hausmanager-logo.png"} alt="Logo" className="max-h-20 object-contain" />
                </div>
                <h1 className="text-2xl font-semibold text-center">{title}</h1>
                {children}
            </div>
        </main>
    )
}
